import React, { useEffect, useMemo, useState } from 'react';
import api from '../api';
import './estilodash.css';

export default function ListarPagamentos() {
  const [pagamentos, setPagamentos] = useState([]);
  const [assinaturas, setAssinaturas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [clienteId, setClienteId] = useState('');

  const carregar = async () => {
    const [p, a, c] = await Promise.all([
      api.get('/api/pagamentos'),
      api.get('/api/assinaturas'),
      api.get('/api/clientes'),
    ]);
    setPagamentos(p.data || []);
    setAssinaturas(a.data || []);
    setClientes(c.data || []);
  };
  useEffect(() => { carregar().catch(console.error); }, []);

  const linhas = useMemo(() => {
    return pagamentos
      .filter(p => !clienteId || String(p.cliente_id) === String(clienteId))
      .map(p => ({
        ...p,
        assinatura: assinaturas.find(a => Number(a.id) === Number(p.assinatura_id)),
        cliente: clientes.find(c => Number(c.id) === Number(p.cliente_id)),
      }))
      .sort((a, b) => String(b.mes_referencia || '').localeCompare(String(a.mes_referencia || '')));
  }, [pagamentos, assinaturas, clientes, clienteId]);

  const marcarPago = async (p) => {
    const valor = Number(p.valor_calculado ?? p.valor ?? 0);
    await api.put(`/api/pagamentos/${p.id}/pagar`, { valor, metodo_pagamento: 'PIX' });
    carregar();
  };

  return (
    <div>
      <h2>Pagamentos</h2>
      <label>Cliente
        <select value={clienteId} onChange={(e) => setClienteId(e.target.value)}>
          <option value="">Todos</option>
          {clientes.map(c => <option key={c.id} value={c.id}>{c.id} - {c.nome}</option>)}
        </select>
      </label>
      <table className="clientes-table">
        <thead><tr><th>ID</th><th>Cliente</th><th>Assinatura</th><th>Mês</th><th>Valor</th><th>Calculado</th><th>Status</th><th>Ações</th></tr></thead>
        <tbody>
          {linhas.map(p => (
            <tr key={p.id}>
              <td>{p.id}</td>
              <td>{p.cliente?.nome || p.cliente_id}</td>
              <td>{p.assinatura ? `${p.assinatura.nome_plano || p.assinatura.codigo_plano || 'Assinatura'} (${p.assinatura.tier})` : (p.assinatura_id || '—')}</td>
              <td>{p.mes_referencia}</td>
              <td>R$ {Number(p.valor || 0).toFixed(2)}</td>
              <td>R$ {Number(p.valor_calculado || 0).toFixed(2)}</td>
              <td>{p.status || '—'}</td>
              <td><button type="button" onClick={() => marcarPago(p)}>Marcar pago</button></td>
            </tr>
          ))}
          {linhas.length === 0 && <tr><td colSpan="8">Nenhum pagamento encontrado.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
